import { render, staticRenderFns } from "./loggingEditor.pug?vue&type=template&id=23e5ba8c&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./loggingEditor.scss?vue&type=style&index=0&id=23e5ba8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e5ba8c",
  null
  
)

export default component.exports